<!-- <iframe
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.7131034887784!2d-99.1550012!3d19.4247981!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1ff41883f153d%3A0x35c7339f2d9878a0!2sEtoy%20Republic!5e0!3m2!1ses!2smx!4v1744779595247!5m2!1ses!2smx"
  width="100%" height="450" style="border: 0" allowfullscreen="" loading="lazy"
  referrerpolicy="no-referrer-when-downgrade" title="Map EtoyRepublic"></iframe> -->
<!-- <img src="https://d2r31p9h1pd7zy.cloudfront.net/assets/img/mapa_tienda_new.webp" class="maps" alt="map_goggle" eager loading="lazy" /> -->
<footer>
  <hr />
  <div class="grid_container">
    <div class="grid d-md-none">
      <img ngSrc="./assets/img/logo_mascot_circle.webp" alt="Logo Etoyrepublic" width="250" height="250" eager alt="Logo Etoy Republic" />
      <p class="mt-3">Síguenos en nuestras redes sociales</p>
      <ul class="social">
        <li>
          <a href="https://www.facebook.com/etoyrepublic" target="_blank" aria-label="Facebook">
            <fa-icon [icon]="iconFB" size="2x"></fa-icon>
          </a>
        </li>
        <li>
          <a href="https://www.instagram.com/etoyrepublic/" target="_blank" aria-label="Instagram">
            <fa-icon [icon]="iconIG" size="2x"></fa-icon>
          </a>
        </li>
      </ul>
      <br />
      <p class="h5">Contáctanos</p>
      <p>contact&#64;etoyrepublic.shop</p>
    </div>
    <div class="grid text-md-end">
      <p class="title_footer">Información</p>
      <ul>
        <li (click)="openTerminos()">Términos y Condiciones</li>
        <li (click)="open()">Política de Devolución y Reembolso</li>
      </ul>
    </div>
    <div class="grid text-center d-md-block d-none">
      <img ngSrc="./assets/img/logo_mascot_circle.webp" alt="Logo Etoyrepublic" width="250" height="250" eager alt="Logo Etoy Republic" />
      <p class="mt-3">Síguenos en nuestras redes sociales</p>
      <ul class="social">
        <li>
          <a href="https://www.facebook.com/etoyrepublic" target="_blank" aria-label="Facebook">
            <fa-icon [icon]="iconFB" size="2x"></fa-icon>
          </a>
        </li>
        <li>
          <a href="https://www.instagram.com/etoyrepublic/" target="_blank" aria-label="Instagram">
            <fa-icon [icon]="iconIG" size="2x"></fa-icon>
          </a>
        </li>
      </ul>
      <br />
      <p class="h5">Contáctanos</p>
      <p>contact&#64;etoyrepublic.shop</p>
    </div>
    <div class="grid text-md-start">
      <div class="item info">
        <p class="title_footer">Categorias</p>
        <ul>
          <li>
            <a [routerLink]="['/']">Inicio</a>
          </li>
          <li>
            <a [routerLink]="['category', 'artoys']"> Art Toys</a>
          </li>
          <li>
            <a [routerLink]="['category', 'sofubi']">Sofubi</a>
          </li>
          <li>
            <a [routerLink]="['category', 'gachapon']">Gachapon</a>
          </li>
          <li>
            <a [routerLink]="['category', 'blindbox']">Blindbox</a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="copy">
    <p>© {{ years }} EToy Republic v1.0.0</p>
  </div>
</footer>
